import React, { useEffect, useState } from "react";
import { SliderPanel } from "../../../components";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faExclamationCircle,
  faPenSquare,
  faTrashAlt,
} from "@fortawesome/pro-light-svg-icons";
import { faAirConditioner, faSort } from "@fortawesome/pro-solid-svg-icons";
import { Form } from "formik";
import { Button, InputGroup } from "react-bootstrap";
import { isEmpty } from "lodash";
import SearchBar from "../../Mapper/LoadDefHomeContainer/SearchBar";
import { useDeepEffect } from "../../../abstracts";

const ExcludedEmployeeClassification = (props) => {
  const {
    employeeClassifications,
    setEmployeeClassifications,
    employeeClassification,
    setEmployeeClassification,
    initialEmployeeClassification,
    planDetails,
    isEdit,
    isSave,
  } = props;
  const [searchString, setSearchString] = useState("");
  const [finalClassification, setFinalClassification] = useState([]);
  const checkBoxClicked = (index) => {
    const changedData = employeeClassification.map((e) => {
      if (index === e.employeeClassificationCodeId) {
        return {
          ...e,
          classificationCheck: !e.classificationCheck,
        };
      } else {
        return e;
      }
    });
    setEmployeeClassification(changedData);
  };
  const classificationCount = () => {
    // if (
    //   !isEmpty(initialEmployeeClassification) &&
    //   isEmpty(finalClassification)
    // ) {
    //   return initialEmployeeClassification.length;
    // } else if (
    //   isEmpty(initialEmployeeClassification) &&
    //   !isEmpty(finalClassification)
    // ) {
    //   return finalClassification.length;
    // } else {
    //   return finalClassification.length;
    // }
    return employeeClassification.filter((x) => x.classificationCheck).length;
  };

  const deleteClassificationMapping = () => {
    setEmployeeClassification(
      !isEmpty(employeeClassification) &&
        employeeClassification.map((e) => {
          return {
            ...e,
            classificationCheck: false,
          };
        })
    );
  };
  const [searchedClassification, setSearchedClassification] = useState([]);
  useDeepEffect(() => {
    setSearchedClassification(employeeClassification);
  }, [employeeClassification]);
  useDeepEffect(() => {
    if (searchString !== "") {
      setSearchedClassification(
        employeeClassification.filter((item) => {
          return item.codeName
            .toLowerCase()
            .includes(searchString.toLowerCase());
          //||
          //team.rkPlanNumber.includes(searchAddedPlans)
        })
      );
    } else {
      setSearchedClassification(employeeClassification);
    }
  }, [searchString]);

  // HAVE TO CLASSIFICATION CHECKX FLAG INITIAL VALUE FROM GET API
  useEffect(() => {
    if (!isEmpty(employeeClassifications)) {
      var listId = initialEmployeeClassification?.map(
        (item) => item.employeeClassificationCodeId
      );
      setEmployeeClassification(
        employeeClassifications.map((e) => {
          if (listId.includes(e.employeeClassificationCodeId))
            return {
              ...e,
              classificationCheck: true,
            };
          else
            return {
              ...e,
              classificationCheck: false,
            };
        })
      );
    }
  }, [employeeClassifications]);

  const [classificationSliderOpen, setClassificationSliderOpen] = useState(
    false
  );
  const addClassification = () => {
    var checkedClassifications = employeeClassification.filter(
      (x) => x.classificationCheck == true
    );
    const results = checkedClassifications.filter(
      ({ id: x }) => !initialEmployeeClassification.some(({ id: y }) => x === y)
    );
    if (results.length > 0) {
      setFinalClassification(results);
      setClassificationSliderOpen(false);
    }
  };
  const cancelClassification = () => {
    var checkedClassifications = employeeClassification.filter(
      (x) => x.classificationCheck == true
    );
    const results = checkedClassifications.filter(
      ({ id: x }) => !initialEmployeeClassification.some(({ id: y }) => x === y)
    );
    if (results.length > 0) {
      setFinalClassification(results);
      setClassificationSliderOpen(false);
    } else {
      setClassificationSliderOpen(false);
    }
  };
  return (
    <>
      <div className="excluded-classification addedPlans-card-font">
        Excluded Employee Classification
      </div>
      {classificationCount() > 0 ? (
        <div
          className="d-flex flex-row excluded-classification-box"
          style={{ width: "45%" }}
        >
          <div className="d-flex flex-col" style={{ width: "70%" }}>
            <span className="employee-classification-added addedPlans-card-font ft-14">
              Employee Classification added
            </span>
            <span className="ft-18 fw-600 excluded-count ">
              {classificationCount()}
            </span>
          </div>
          <div
            className="d-flex flex-row marg-right-15"
            style={{ width: "30%" }}
          >
            <FontAwesomeIcon
              onClick={() => setClassificationSliderOpen(true)}
              className="fee-edit-icon"
              icon={faPenSquare}
            />
            <FontAwesomeIcon
              onClick={() => deleteClassificationMapping()}
              className="fee-delete-icon"
              icon={faTrashAlt}
            />
          </div>
        </div>
      ) : (
        <div className="d-flex flex-col excluded-classification-box-empty">
          <span className="ft-16 addedPlans-card-font marg-bot-20 excluded-count">
            No employee classification(s) added
          </span>
          <Button
            onClick={() => !isEdit && setClassificationSliderOpen(true)}
            variant="secondary"
            style={{
              width: "fit-content",
              cursor: isEdit ? "not-allowed" : "default",
            }}
          >
            Add Classification
          </Button>
        </div>
      )}
      <SliderPanel
        isOpen={classificationSliderOpen}
        size="40"
        showCancelButton={true}
        showCancel={false}
        onClose={() => cancelClassification()}
        showSave={true}
        onSave={() => addClassification(employeeClassification)}
        showHeader={true}
        header="Excluded Employee Classification"
        headerClass="slider-title-case"
        backdropClicked={() => {
          setClassificationSliderOpen(false);
        }}
      >
        <div className="plan-details-card">
          <div className="w-50">
            <p className="plan-name-header">Plan name</p>
            <p className="plan-name-value">{planDetails[0].planName}</p>
          </div>
          <div>
            <p className="plan-name-header">Plan ID</p>
            <p className="plan-name-value">{planDetails[0].rkPlanNumber}</p>
          </div>
        </div>
        <div className="w-100" style={{ padding: "10px 0px 20px 0px" }}>
          <div className="flex-search">
            <InputGroup>
              <InputGroup.Prepend>
                <div className="searchIconPostion">
                  <i class="fal fa-search" aria-hidden="true"></i>
                </div>
              </InputGroup.Prepend>

              <SearchBar
                size="md"
                type="search"
                placeholder="Search plan group name"
                className="PadLeftSearch"
                onChange={
                  (e) => setSearchString(e.target.value)
                  //console.log(e.target.value)
                }
              />
            </InputGroup>
          </div>
        </div>
        <div className="classification-count-card">
          <FontAwesomeIcon
            icon={faExclamationCircle}
            className="mr-1 ft-16 fw-500"
            style={{ color: "#067492", marginTop: "3px" }}
          />
          <p className="mb-0 fw-500 ft-14" style={{ color: "#067492" }}>
            {classificationCount() > 0 && classificationCount()} Employee
            classification selected
          </p>
        </div>
        <div
          className="d-flex flex-row"
          style={{ padding: "15px", textAlign: "center" }}
        >
          <p
            className="mr-1 mb-0 ft-14 ft-16 "
            style={{ color: "#919191", marginTop: "3px" }}
          >
            Employee Classification Name
          </p>
          <FontAwesomeIcon
            icon={faSort}
            className="mr-1 ft-14 fw-300 mt-2"
            style={{ color: "#919191" }}
          />
        </div>
        <div className="classification-cards">
          {!isEmpty(employeeClassification) &&
          searchedClassification.length != 0 ? (
            searchedClassification.map((item, index) => (
              <div className="fee-classification-card">
                <div
                  className="d-flex"
                  style={{ justifyContent: "center", textAlign: "center" }}
                >
                  <input
                    type="checkbox"
                    id={index}
                    onClick={() =>
                      checkBoxClicked(item.employeeClassificationCodeId)
                    }
                    checked={item.classificationCheck}
                  />
                  <label for={index} className="ml-2 mb-0">
                    {" "}
                    {item.codeName}
                  </label>
                </div>
              </div>
            ))
          ) : (
            <div className="p-2 fw-600">No Result found</div>
          )}
        </div>
      </SliderPanel>
    </>
  );
};
export default ExcludedEmployeeClassification;
